import React from "react";
import { Col, Row } from "antd";
import { Card, LoadingSpinner, Switcher } from "pepsico-ds";
import MultiSelectDropdown from "../../../components/Dropdown/MultiSelectDropdown";
import SingleSelectDropdown from "../../../components/Dropdown/SingleSelectDropdown";
import reset_icon from "../../../assets/reset_icon.svg";
import CommonTable from "../../../components/Table/CommonTable";
import RisiLineChart from "../../../components/Charts/RISIChart/RisiLineChart";
import NoData from "../../../components/NoData/NoData";
import LegendList from "../../../components/Charts/Legend/LegendList";
import ActualLegendRISI from "../../../assets/ActualLegendRISI.svg";
import InfoIcon from "../../../components/Icons/InfoIcon";
import DropdownWithIcons from "../../../components/Modal/DropdownWithIcons";
import { useRisiSource } from "./RisiSourceContext";

// RISI (FASTMARKETS) source component. RISI state, redux selectors, handler
// functions and effects live in RisiSourceContext.js (shared via
// RisiSourceProvider), ported over from the standalone RISIScreen.js, so
// that RISI logic is fully self-contained; this component only renders the
// "filters" or "content" slice of the RISI UI depending on `section`, the
// same way CmaSource/SmartCubeSource render their own slices.
const RisiSource = props => {
  const { section } = props;
  const {
    roleSelected,
    sectors, sectorSelected, onSectorChange,
    businessUnits, businessUnitSelected, onBusinessUnitChange,
    categoryL0Selected, categoryL1Selected,
    fromDates, toDates, fromDateSelected, toDateSelected, onFromDateChange, onToDateChange,
    commodities, commoditySelected, onCommodityChange,
    indexes, indexSelected, onIndexChange,
    locations, locationSelected, onLocationChange,
    currencies, currencySelected, onCurrencyChange,
    onFiltersReset,
    switcherIndex, setSwitcherIndex,
    chartData, forecastStartVal, risiSeriesLineChartIndex, risiLineChartLegends,
    firstForecastYearMonth, firstForecastKeysToBeMergedActualLAst, lineChartactualData,
    risiTableData, risiTableColumns, risiTableColumnMapping, risiColumnsToInclude,
    risiLineChartRef,
    checkPDFDownloaded,
    isDataLoading
  } = useRisiSource();

  return (
    <>
      {section === "filters" && (
        <div style={{ width: "100%" }}>
          <Row gutter={[10, 10]} justify="start" style={{ width: "100%", marginTop: "12px" }}>
            {/* <Col flex="1">
              <SingleSelectDropdown placeholder="View" className="buy-con-dropdown-modal" label="View" childList={roleSelected} selectedValue={roleSelected} setSelectedValue={{}} disabled={true} />
            </Col> */}
            <Col flex="1">
              <MultiSelectDropdown placeholder="Sectors" className="buy-con-dropdown-modal" label="Sector" childList={sectors} selectedValue={sectorSelected} setSelectedValue={onSectorChange} />
            </Col>
            <Col flex="1">
              <MultiSelectDropdown placeholder="BUs" className="buy-con-dropdown-modal" label="Business Unit / Market" childList={businessUnits} selectedValue={businessUnitSelected} setSelectedValue={onBusinessUnitChange} />
            </Col>
            {/* <Col flex="1">
              <SingleSelectDropdown placeholder="Categories L0" className="buy-con-dropdown-modal" label="Category L0" disabled={true} setSelectedValue={{}} selectedValue={categoryL0Selected} childList={categoryL0Selected} />
            </Col>
            <Col flex="1">
              <SingleSelectDropdown placeholder="Categories L1" disabled={true} setSelectedValue={{}} label="Category L1" className="buy-con-dropdown-modal" selectedValue={categoryL1Selected} childList={categoryL1Selected} />
            </Col> */}
            <Col flex="1">
              <SingleSelectDropdown placeholder="Currency" className="buy-con-dropdown-modal risi-dropdown" label="Currency" childList={currencies} selectedValue={currencySelected} setSelectedValue={onCurrencyChange} />
            </Col>
            <Col flex="1">
              <SingleSelectDropdown setSelectedValue={onFromDateChange} selectedValue={fromDateSelected} childList={fromDates} label="From Date" className="buy-con-dropdown-modal" />
            </Col>
            <Col flex="1">
              <SingleSelectDropdown className="buy-con-dropdown-modal" label="To Date" setSelectedValue={onToDateChange} selectedValue={toDateSelected} childList={toDates} />
            </Col>
          </Row>

          <Row gutter={[10, 10]} justify="start" style={{ width: "100%", marginTop: "12px" }}>
            <Col xs={24} sm={24} md={4} lg={4} xl={4}>
              <MultiSelectDropdown placeholder="Commodity" className="buy-con-dropdown-modal risi-dropdown" label="Commodity" childList={commodities} selectedValue={commoditySelected} setSelectedValue={onCommodityChange} />
            </Col>
            <Col xs={24} sm={24} md={16} lg={16} xl={16}>
              <MultiSelectDropdown placeholder="Index" className="buy-con-dropdown-modal risi-dropdown" label="Index (Select up to 5)" childList={indexes} selectedValue={indexSelected} setSelectedValue={onIndexChange} />
            </Col>
            <Col xs={24} sm={24} md={4} lg={4} xl={4}>
              <MultiSelectDropdown placeholder="RISI Location" className="buy-con-dropdown-modal risi-dropdown" label="RISI Location" childList={locations} selectedValue={locationSelected} setSelectedValue={onLocationChange} />
            </Col>
            
          </Row>

          <Row justify="end">
            <button className="reset-button" onClick={onFiltersReset} style={{ marginTop: "12px", marginRight: "0.8rem", marginBottom: "24px" }}>
              <img src={reset_icon} className="reset_icon" alt="Reset Icon" />
              <span>Reset Filters</span>
            </button>
          </Row>
        </div>
      )}

      {section === "content" && (
        <Row justify="start" style={{ width: "100%" }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Card style={{ height: "100%", padding: "24px", width: "100%" }}>
              {isDataLoading ? (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: 300 }}>
                  <LoadingSpinner size={{ height: "80px", width: "80px" }} />
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    position: "relative",
                    width: "100%",
                    minWidth: 0,
                    gap: "16px"
                  }}
                >
                  <Row gutter={[16, 16]} justify="start" style={{ width: "100%", minWidth: 0 }}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      <div ref={risiLineChartRef}>
                        <div className="sba-cci-linechart-section" style={{ minHeight: "auto", maxHeight: "none" }}>
                          <div style={{ display: "flex", flexDirection: "column", gap: "16px", width: "100%", background: "#fff" }}>
                            <div
                              className="resin_linechart_header"
                              style={{ width: "100%", alignItems: "center", textAlign: "left", display: "flex", justifyContent: "space-between", fontSize: "16px" }}
                            >
                              <span className="cma-charts-title" style={{ fontSize: "16px"}}>Commodity Index Price Movement and Forecast</span>
                              <span>
                                <DropdownWithIcons modalRef={risiLineChartRef} kpiName={"Commodity Index Price Movement and Forecast"} checkPDFDownloaded={checkPDFDownloaded} />
                              </span>
                            </div>
                            {chartData && chartData?.length > 0 ? (
                              <>
                                <div style={{ width: "100%", textAlign: "right", display: "flex", justifyContent: "space-between" }}>
                                  <div>
                                    <img src={ActualLegendRISI} alt="img" style={{ marginRight: "1rem" }} />
                                    <span style={{ marginRight: "0.25rem", position: "relative", top: "3px" }}>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <line x1="0" y1="6" x2="12" y2="6" stroke={"#616161"} strokeWidth="2" strokeLinecap="round" strokeDasharray="5 0" />
                                      </svg>
                                    </span>
                                    <span style={{ marginRight: "0.25rem", position: "relative", top: "3px" }}>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <line x1="0" y1="6" x2="18" y2="6" stroke={"#616161"} strokeWidth="2" strokeLinecap="round" strokeDasharray="5 0" />
                                      </svg>
                                    </span>
                                    <span style={{ color: "#616161", position: "relative", top: "2px" }}>Forecast</span>
                                  </div>
                                  <div style={{ float: "right", position: "relative", right: "1.25rem" }}>
                                    <Switcher
                                      className=""
                                      items={[
                                        { label: "Low", leadingIcon: "edit", showLeadingIcon: false },
                                        { label: "Mid", leadingIcon: "edit", showLeadingIcon: false },
                                        { label: "High", leadingIcon: "edit", showLeadingIcon: false }
                                      ]}
                                      selectedItemIndex={0}
                                      onUpdate={val => setSwitcherIndex(val)}
                                      style={{}}
                                    />
                                    <span className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>
                                      <InfoIcon
                                        style={{ position: "relative", top: "0.5rem", left: "0.5rem" }}
                                        direction={"left"}
                                        text={`RANGE
                                        Low: Lower bound of the price range. Example: 38
                                        Mid: Midpoint or average of the price range. Example: 38.5
                                        High: Upper bound of the price range. Example: 39`}
                                      />
                                    </span>
                                  </div>
                                </div>
                                <RisiLineChart
                                  rawData={chartData}
                                  forecastStartLabel={forecastStartVal}
                                  risiSeriesLineChartIndex={risiSeriesLineChartIndex}
                                  firstForecastYearMonth={firstForecastYearMonth}
                                  firstForecastKeysToBeMergedActualLAst={firstForecastKeysToBeMergedActualLAst}
                                  lineChartactualData={lineChartactualData}
                                />
                                <LegendList legends={risiLineChartLegends} />
                              </>
                            ) : (
                              <NoData />
                            )}
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]} justify="start" style={{ width: "100%", minWidth: 0 }}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      <div className="sba-cci-linechart-section" style={{ overflowX: "auto", minHeight: "auto", maxHeight: "none" }}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "16px", width: "100%", minWidth: 0, background: "#fff" }}>
                          {risiTableData && risiTableData?.length > 0 ? (
                            <div className="ph-table-wrapper" style={{ width: "100%", minWidth: 0, overflowX: "auto" }}>
                              <CommonTable
                                className="risi-table"
                                data={risiTableData}
                                columns={risiTableColumns}
                                tableHeader={"Commodity Indices Details"}
                                enableSorting={true}
                                columnsToInclude={risiColumnsToInclude}
                                columnMapping={risiTableColumnMapping}
                                tableName={"Commodity Indices Details"}
                              />
                            </div>
                          ) : (
                            <>
                              <div style={{ width: "100%", textAlign: "left", fontSize: 18, fontWeight: 700, color: "#3a3a3a" }}>Commodity Indices Details</div>
                              <NoData />
                            </>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
            </Card>
          </Col>
        </Row>
      )}
    </>
  );
};

export default RisiSource;
